import { Cashier } from '@mews-commander/data-access';

export const getCurrencyDefaultValue = (defaultCurrencyCode: string, cashier?: Cashier) =>
    cashier?.enabledCurrencies.find(({ code }) => code === defaultCurrencyCode)?.code ||
    cashier?.enabledCurrencies[0].code;
